<template>
 <div id="tab1" class="t-color-bodyGrayB pdl-16 pdr-16 pdt-16 pdb-34" style="height:100vh">
        <!-- <div class="h-50"></div>
        <div class="h-32"></div> -->
        <img src="images/helpdesk/notice_nodata.svg" alt="" class="mgx-auto no-data-image">
        <div class="pdt-24 pdl-16 pdr-16 pdb-4 t-subtitle3 t-color-headlineBlack t-center font-m l-spacing48">{{ $t('1494') }}
        </div>
        <div class="pdt-4 pdl-16 pdr-16 pdb-4 t-body3 t-color-bodyGrayA t-center l-spacing42">{{ $t('1495') }}</div>

    </div>

        
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {

}
</script>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
}
.nav-extended .brand-logo,
.nav-content * {
  font-family: noto-regular;
}

.nav-extended .brand-logo {
  font-size: 20px;
  letter-spacing: -0.6;
}

.tabs .tab a:focus,
.tabs .tab a:focus.active {
  background-color: #f5f5f5;
  outline: none;
}

.tabs .indicator {
  background: #2d6dcc;
}

.mdc-elevation--z3 {
            border-radius: 4px;
            box-shadow: 0 1px 3px 0 var(--Shadow1);
            background-color: var(--DocumentWhite);
        }

.tabs .tab {
  width: 50%;
}
.listItems {
  border-bottom: 1px solid var(--Divider);
}
.no-data-image {
            width: 123px;
            height: 143px;
        }

#tab1, #tab2{
    margin-top: 56px;
}
</style>